export type HighlightType = {
  topic: string
  content: string
}

type HighlightProps = {
  highlights: HighlightType[]
}

const Highlight = ({ highlights }: HighlightProps) => {
  return (
    <div className="relative">
      <div className="container mx-auto max-w-6xl">
        <div className="mx-2 flex flex-wrap md:justify-center md:gap-3 p-2 bg-blue-50 bg-opacity-25 border rounded-sm border-grey-400">
          {highlights.map((highlight, index) => {
            return (
              <>
                <div key={index} className="p-3 font-600 w-1/2 md:w-auto">
                  <p className="text-orange">{highlight.topic}</p>
                  <p dangerouslySetInnerHTML={{ __html: highlight.content }} />
                </div>
                {index !== highlights.length - 1 && (
                  <div className="py-3">
                    <span className="hidden md:block h-full border-grey-400 border"></span>
                  </div>
                )}
              </>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Highlight
